import {createFileRoute, Outlet} from '@tanstack/react-router'

export const Route = createFileRoute('/_authed/admin/organizations/$orgId')({
    component: AdminOrganizationDetailLayout,
})

function AdminOrganizationDetailLayout() {
    return <Outlet />
}
